module.exports = __webpack_public_path__ + "static/images/intro3_579430bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intro/intro3.png
// module id = 231
// module chunks = 1